import { ImpactEvaluationItem, MappedEvaluationItem, EvaluationStatus } from './types';
import { DATE_FORMAT_OPTIONS } from './constants';
import { ImpactEvaluationStatus } from 'types/evaluation';

export const mapEvaluationData = (data: ImpactEvaluationItem[]): MappedEvaluationItem[] => {
  return data.map((item) => ({
    title: item.title,
    availableAt: item.creationDate 
      ? new Date(item.creationDate).toLocaleDateString('pt-BR', DATE_FORMAT_OPTIONS)
      : '-',
    expiresAt: item.expirationDate
      ? new Date(item.expirationDate).toLocaleDateString('pt-BR', DATE_FORMAT_OPTIONS)
      : '-',
    status: determineStatus(item),
    idQuestionnaire: item.idQuestionnaire,
    idEvaluation: item.idEvaluation,
    idEnrollment: item.idEnrollment,
    idUser: item.idUser,
    startDate: item.startDate,
    finishDate: item.finishDate,
  }));
};

export const determineStatus = (item: ImpactEvaluationItem): EvaluationStatus => {
  if (item.finishDate) {
    return ImpactEvaluationStatus.FINISHED;
  }
   
  if (item.expirationDate) {
    const now = new Date();
    const expirationDate = new Date(item.expirationDate);
    
    if (expirationDate < now) {
      return ImpactEvaluationStatus.EXPIRED;
    }
  }
  
  return ImpactEvaluationStatus.PENDING;
};
